var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSenasteNytt = function SvgSenasteNytt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea4d33",
    fillRule: "evenodd",
    d: "M14.76 5.036c14.75-9.948 38.07-3.905 47.03 9.38s13.495 34.653-1.255 44.602c-14.766 9.96-46.652 4.235-55.612-9.049C-4.26 36.352.01 14.985 14.76 5.037"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 38,
    height: 34,
    x: 17,
    y: 18,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.93 18.087h36.894v33.425H17.93z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M53.932 37.363a1.91 1.91 0 0 1-1.918 1.9h-.85c.395-2.015.68-4.271.68-6.668 0-2.059-.21-4.014-.517-5.802h.687c1.057 0 1.918.852 1.918 1.9zm-5.504 8.214a1 1 0 0 1-.564.57 1.04 1.04 0 0 1-.824-.02l-15.7-7.147c.32-1.316.907-4.046.907-6.385s-.585-5.07-.907-6.386l15.701-7.146a1.03 1.03 0 0 1 1.165.205 1 1 0 0 1 .222.343c.943 2.43 2.526 7.35 2.526 12.983s-1.583 10.552-2.526 12.983M25.677 41.32l3.065 7.93c.123.318.08.66-.114.94a1.02 1.02 0 0 1-.847.44h-2.503a1.03 1.03 0 0 1-.996-.758l-2.576-9.711c-.02-.077-.066-.138-.095-.212a16 16 0 0 0 1.933.14c.687 0 1.47-.078 2.157-.168a1.87 1.87 0 0 0-.024 1.4zm-6.856-3.595v-10.26c0-.563.46-1.019 1.029-1.019H30.4c.027 0 .052-.007.078-.008.311 1.288.878 3.945.878 6.157s-.567 4.868-.878 6.157c-.026-.002-.05-.009-.078-.009h-2.93c-.207 0-.405.043-.595.106-.69.121-2.19.358-3.332.358-.96 0-2.17-.167-2.943-.293a1.9 1.9 0 0 0-.751-.17 1.026 1.026 0 0 1-1.029-1.019zM52.014 25.91h-.854a40 40 0 0 0-1.901-6.615 1.87 1.87 0 0 0-1.06-1.07 1.96 1.96 0 0 0-1.53.035l-15.84 7.211a1 1 0 0 1-.43.093H19.85a1.91 1.91 0 0 0-1.92 1.9v10.26c0 .942.698 1.72 1.61 1.869a.4.4 0 0 0 .123.051 40 40 0 0 0 .682.121c.239.132.426.345.499.62l2.578 9.712a1.92 1.92 0 0 0 1.857 1.415h2.503c.633 0 1.224-.308 1.581-.823a1.88 1.88 0 0 0 .213-1.754l-3.065-7.928a1 1 0 0 1 .112-.941c.149-.214.374-.33.62-.386l.184-.035c.018-.003.032-.014.05-.02H30.4a1 1 0 0 1 .43.093l15.839 7.21c.482.218 1.04.233 1.53.037a1.87 1.87 0 0 0 1.06-1.07 40 40 0 0 0 1.723-5.75h1.031c1.549 0 2.81-1.247 2.81-2.781v-8.671a2.8 2.8 0 0 0-2.81-2.782z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m46.823 21.347-1.105.518a.59.59 0 0 0-.149.953.57.57 0 0 0 .626.103l1.104-.518a.59.59 0 0 0 .28-.771.565.565 0 0 0-.756-.285m-3.736 1.111-9.211 4.643c-.22.111-.315.397-.215.636a.44.44 0 0 0 .398.28.4.4 0 0 0 .182-.044l9.21-4.642a.5.5 0 0 0 .216-.637c-.103-.242-.367-.348-.58-.236"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgSenasteNytt;